import axios from 'axios';

async function Post(endpoint, data, headers={}) {
  // console.log(data);
  try {
    const response = await axios.post(endpoint, data, { 
      headers,
      withCredentials: false
    });
    return response.data;
  } catch (error) {
    console.error('Error occurred while making POST request:', error);
    throw error;
  }
}

export default Post;